import { action, computed, makeObservable, observable } from 'mobx';
import { BaseAlert } from '@context/global/typescript';

class AlertsStore {
  public alerts: Array<BaseAlert> = [];

  constructor() {
    makeObservable(this, {
      alerts: observable,
      pushAlert: action,
      hideAlert: action,
      currentAlert: computed,
    });
  }

  get currentAlert(): BaseAlert | null {
    return this.alerts.length === 0 ? null : this.alerts[0];
  }

  hideAlert = () => {
    if (this.alerts.length > 0) {
      this.alerts.shift();
    }
  };

  pushAlert = (alert: BaseAlert) => {
    this.hideAlert();
    this.alerts.push({ ...alert, display: true });
  };
}

const alertsStore = new AlertsStore();
export default alertsStore;
